import { FC } from "react";
import "./CalendarPassWelcomeScreen.css";
import { useNavigate } from "react-router-dom";
import whiteArrow from "../../../assets/images/white-arrow.svg";
import passAppIcon from "../../../assets/images/calendar-pass-app-icon.svg";
import ROUTE_PATHS from "utils/routePaths";

const CalendarPassWelcomeScreen: FC = () => {
  const navigate = useNavigate();

  const handleProccedClick = () => {
    navigate(
      ROUTE_PATHS.WSM_CALENDAR_PASS_INTRODUCTION_SCREEN.replace(":stage", "1"),
    );
  };

  return (
    <div className="wms-mobile-container">
      <div className="calendar-pass-welcome-screen-container">
        <div className="calendar-pass-welcome-screen-bg-container">
          <img src={passAppIcon} alt="pass-app-icon" className="app-icon " />
        </div>
        <div
          className="calendar-pass-welcome-screen-btn"
          onClick={handleProccedClick}
        >
          FIND WHAT'S BLOCKING YOU.
          <img src={whiteArrow} alt="white-arrow-icon" />
        </div>
      </div>
    </div>
  );
};

export default CalendarPassWelcomeScreen;
